import React from 'react';
function Footer(){
	return(
			<div style={{width:"100vw",backgroundColor:"black",padding:"20px 0",display:"flex",justifyContent:"space-between"}}>
				<p className="" style={{fontWeight:"500",padding:"0 40px",color:"white",fontSize:"18px",margin:"0"}}>Version : 2.0.1 </p>
				<p className="" style={{fontWeight:"500",padding:"0 40px",color:"white",fontSize:"18px",margin:"0"}}>Empowered by Brighton Cloud Technologies</p>
			</div>
		)
}
export default Footer;